<template>
    <div class="page-header">
        <div class="collapse" @click="handleCollapseToggle">
            <i
                class="el-icon-s-fold icon-color"
                :class="{ 'icon-rotate': isCollapse }"
            ></i>
        </div>
        <div class="right">
            <el-popover
                placement="bottom"
                width="220"
                trigger="manual"
                v-model="helperPopoverVisible"
            >
                <div class="helper" @click="handleClickHelper" slot="reference">
                    <img
                        class="helper-icon"
                        src="@/assets/imgs/helper.png"
                        alt="播货助手"
                    />
                    <div class="helper-text">播货助手</div>
                </div>
                <div class="helper-content">
                    <div class="content__header">播货助手，你的卖货小帮手</div>
                    <div class="content__btn">
                        <el-button
                            type="primary"
                            size="mini"
                            @click="handleOpenBrowser"
                            >浏览器打开</el-button
                        >
                        <el-button
                            type="primary"
                            size="mini"
                            @click="handleCopyLink"
                            >复制链接</el-button
                        >
                    </div>
                </div>
            </el-popover>

            <el-dropdown trigger="click">
                <span class="user">
                    <img v-if="avatar" class="avatar" :src="avatar" alt="" />
                    <span>{{ userName }}</span>
                    <i class="el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <div @click="handleLogout">
                            退出登录
                        </div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <div @click="handleProfile">
                            个人中心
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
import { signOutHandler } from '@/common/api';
import { mapGetters } from 'vuex';
import { removeCookie } from '@/utils/cookie';
import { avatarDefault } from '@/common/config';
export default {
    name: 'Header',
    data() {
        return {
            userName: this.$store.state.userInfo.nickName,
            avatar: this.$store.state.userInfo.headPortrait || avatarDefault,
            helperPopoverVisible: false,
            helperUrl: `https://bhh5.sisiim.com/#/saas/login?tenantId=${this.$store.state.userInfo.tenantId}`
        };
    },
    computed: {
        ...mapGetters(['isCollapse', 'userInfo'])
    },
    watch: {
        'userInfo.headPortrait'(val) {
            this.avatar = val;
        }
    },
    methods: {
        // 退出登录
        logout() {
            signOutHandler()
                .then(res => {
                    const { code, success } = res;
                    if (code === 0 && success) {
                        // 清空token
                        removeCookie('token', {
                            domain: location.hostname.replace(/.*?\./, '')
                        });
                        this.$message({
                            message: '退出成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => {
                                const {
                                    dccTenantAjmdLogoutUrl
                                } = this.$store.getters.userInfo;
                                if (dccTenantAjmdLogoutUrl) {
                                    window.location.href = dccTenantAjmdLogoutUrl;
                                } else {
                                    window.location.reload();
                                }
                            }
                        });
                    }
                })
                .catch(error => {
                    this.$message.error(
                        (error.data || {}).message || '操作异常'
                    );
                });
        },
        handleLogout() {
            this.$confirm('确定退出登录吗?', '退出登录提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'submit-btn',
                type: 'warning'
            })
                .then(() => {
                    this.logout();
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消退出登录'
                    });
                });
        },
        // 收起侧边栏
        handleCollapseToggle() {
            window.localStorage.setItem(
                'isCollapse',
                this.isCollapse ? 'false' : 'true'
            );
            this.$store.dispatch('set_IsCollapse', !this.isCollapse);
        },
        handleProfile() {
            this.$router.push({
                path: '/profile'
            });
            this.$emit('router-change', true);
        },
        handleClickHelper() {
            this.helperPopoverVisible = !this.helperPopoverVisible;
        },
        handleOpenBrowser() {
            window.open(this.helperUrl);
            this.handleClickHelper();
        },
        handleCopyLink() {
            try {
                window.navigator.clipboard.writeText(this.helperUrl).then(
                    () => {
                        this.$message({
                            message: '复制成功',
                            type: 'success'
                        });
                    },
                    res => {
                        this.$message.error(res);
                    }
                );
                this.handleClickHelper();
            } catch (error) {
                this.$message.error(error);
            }
            if (!window.navigator.clipboard) {
                this.$message.error(
                    '暂不支持复制链接，请切换到安全协议(https)尝试'
                );
            }
        }
    }
};
</script>
<style lang="scss">
.el-message-box {
    .submit-btn {
        color: #fff;
        background-color: #ff585e !important;
        border-color: #ff585e !important;
    }
}
</style>
<style lang="scss" scoped>
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #ffeeef;
    color: #ff797e;
}

.page-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-top: 10px;
    background: #f8f8f8;
    height: 58px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 21px;
    .collapse {
        cursor: pointer;
    }
    .icon-color {
        color: #7e8d98;
        font-size: 18px;
    }
    .icon-rotate {
        transform: rotate(90deg);
    }
    .user {
        cursor: pointer;
        display: flex;
        align-items: center;
        .avatar {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            margin: 0 8px 0 0;
        }
    }
    .right {
        display: flex;
        align-items: center;
        .helper {
            margin-right: 20px;
            display: flex;
            align-items: center;
            .helper-icon {
                width: 20px;
                height: 20px;
                margin-right: 3px;
            }
            .helper-text {
                color: #333333;
                font-size: 14px;
                line-height: 25px;
            }
        }
        .helper:hover {
            cursor: pointer;
        }
    }
}
.helper-content {
    .content__header {
        text-align: center;
        margin-bottom: 10px;
    }
    .content__btn {
        display: flex;
        justify-content: space-between;
    }
}
</style>
